import { css } from 'aphrodite';
import { Button } from '../../../../../web/components/Button';
import { pink2, successTint } from '../../../../../web/styles/colors';
import { baseStyleSheet } from '../../../../../web/styles/styles';
import { IEventRegistrationSurvey, IEventSurveyResponse } from '../../../../models/Api';
import { AddToCalendarDropdown } from '../AddToCalendarDropdown';
import { getEventRecipientFirstAndLastName } from '../utils';
import { styleSheet } from './styles';

type Props = {
	onChangeResponseClick: () => void;
	surveyResponse: IEventSurveyResponse;
	survey: IEventRegistrationSurvey;
};

export const EventSurveyConfirmation = ({ onChangeResponseClick, surveyResponse, survey }: Props) => {
	return (
		<div className={css(styleSheet.container)}>
			<EventResponseMessage surveyResponse={surveyResponse} survey={survey} />
			<div className={css(styleSheet.divider)} />
			<div className={css(styleSheet.buttonGroup)}>
				{surveyResponse.isAttending && <AddToCalendarDropdown survey={survey} surveyResponseId={surveyResponse.id} />}
				<Button label='Change Response' onClick={onChangeResponseClick} />
			</div>
		</div>
	);
};

const EventResponseMessage = ({
	surveyResponse,
	survey,
}: { surveyResponse: IEventSurveyResponse; survey: IEventRegistrationSurvey }) => {
	const hasNamedGuests = !!surveyResponse.guests?.length;
	const anonymousGuests = surveyResponse.anonymousGuestCount;

	const addAdditionalAnonymousGuestCount = () => {
		if (anonymousGuests) {
			return `and ${anonymousGuests} other guest${anonymousGuests === 1 ? '' : 's'}`;
		}
		return '';
	};

	const getGuestContent = () => {
		if (hasNamedGuests) {
			return (
				<>
					<span>with the following guests:&nbsp;</span>
					{surveyResponse.guests.map((guest, index) => {
						const { firstName, lastName } = getEventRecipientFirstAndLastName(guest);
						return (
							<strong
								key={`${firstName}-${lastName}`}
								className={css(baseStyleSheet.fontBold)}
							>{`${firstName} ${lastName}${index !== surveyResponse.guests.length - 1 ? ',' : ''} `}</strong>
						);
					})}
					{addAdditionalAnonymousGuestCount()}
				</>
			);
		} else if (anonymousGuests) {
			return anonymousGuests > 1 ? <span>with {anonymousGuests} guests</span> : <span>with a guest</span>;
		}
	};
	return (
		<div
			className={css(styleSheet.eventResponseMessage)}
			style={{ background: surveyResponse.isAttending ? successTint : pink2 }}
		>
			<div>
				<p>
					You have marked that you&nbsp;
					<strong className={css(baseStyleSheet.fontBold)}>
						{surveyResponse.isAttending ? 'are attending' : 'are not attending'}
					</strong>
					&nbsp;this event&nbsp;
					{getGuestContent()}
				</p>
				{surveyResponse.isAttending && survey?.isPaidEvent ? (
					<p>Please check your email for your tickets and event details</p>
				) : null}
			</div>
		</div>
	);
};
